import Route from '@ember/routing/route';

export default class ResourcesRoute extends Route {}
